import { ref, deleteObject } from "firebase/storage";
import { doc, deleteDoc, getDoc } from "firebase/firestore";
import { storage, db } from "../../../../firebase";

/**
 * Custom hook providing file deletion functionality for user files.
 * Deletes file from Firebase Storage and Firestore document.
 */
export function useDeleteFileUser() {
  /**
   * Deletes a file from Firebase Storage and Firestore.
   * @param {Object} file - The file object containing metadata.
   * @param {string} file.userId - ID of the user who owns the file.
   * @param {string} file.folderId - ID of the folder containing the file.
   * @param {string} file.storagePath - Storage path of the file in Firebase Storage.
   * @param {string} file.fileId - Firestore document ID of the file.
   * @param {number} file.subfolderIndex - Index of the subfolder containing the file.
   * @returns {Promise<void>} Resolves when deletion is complete.
   */
  async function deleteFile(file, subfolderId) {
    if (
      !file ||
      !file.userId ||
      !file.folderId ||
      !file.storagePath ||
      !file.fileId
    ) {
      console.log(
        file.userId,
        file.folderId,
        file.storagePath,
        file.fileId,
        subfolderId
      );
      throw new Error("Missing required file metadata for deletion.");
    }

    console.log("deleteFile invoed from useDeleteFileUser.js....", file);

    // Delete from Firebase Storage
    const storageRef = ref(storage, file.storagePath);
    await deleteObject(storageRef);

    console.log("Deleted From Storage....");

    // Delete Firestore document
    const fileDocRef = doc(
      db,
      "users",
      file.userId,
      "folders",
      file.folderId,
      "subfolders",
      subfolderId,
      "files",
      file.fileId
    );
    console.log(
      "Firestore doc ref path:",
      "users",
      file.userId,
      "folders",
      file.folderId,
      "subfolders",
      subfolderId,
      "files",
      file.fileId
    );

    try {
      // Check if document exists before deleting
      const docSnap = await getDoc(fileDocRef);
      if (docSnap.exists()) {
        await deleteDoc(fileDocRef);
        console.log("Deleted Firestore document successfully.");
      } else {
        console.log("Firestore document does not exist, skipping deletion.");
      }
    } catch (err) {
      console.error("Error deleting Firestore document:", err);
      // Optional: retry logic could be added here if needed
    }
  }

  return { deleteFile };
}
